import {
  SessionIntentionNotificationCadence,
  SessionIntentionNotificationTimeOfDay,
} from '@grow-therapy-team/seedling-components';

export enum SessionIntention__CreatedBy {
  CLIENT = 'CLIENT',
  PROVIDER = 'PROVIDER',
}

export enum SessionIntention__EditedBy {
  CLIENT = 'CLIENT',
  PROVIDER = 'PROVIDER',
}

export interface SessionIntention {
  shortId: string;
  appointmentShortId: string;
  clientUserShortId: string;
  providerShortId: string;
  contentText: string;
  contentImageUrl: string | null;
  notificationCadence: SessionIntentionNotificationCadence | null;
  notificationTimeOfDay: SessionIntentionNotificationTimeOfDay | null;
  expiredAt: string | null;
  createdBy: SessionIntention__CreatedBy;
  editedBy: SessionIntention__EditedBy | null;
}
